import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Contact, Document, PaymentInfo, VendorData } from "./vendor.type";

export interface InitialVendorSlice {
  vendorDate: VendorData | null;
}

const initialState: InitialVendorSlice = {
  vendorDate: null,
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    // Set the entire vendor object
    setVendor: (state, action: PayloadAction<VendorData>) => {
      state.vendorDate = action.payload;
    },

    // Update general info fields
    updateGeneralInfo: (
      state,
      action: PayloadAction<
        Partial<Omit<VendorData, "contacts" | "documents" | "paymentInfo">>
      >,
    ) => {
      if (state.vendorDate) {
        state.vendorDate = { ...state.vendorDate, ...action.payload };
      } else {
        state.vendorDate = action.payload as VendorData;
      }
    },

    // Update contacts array
    updateContacts: (state, action: PayloadAction<Contact[]>) => {
      if (state.vendorDate) {
        state.vendorDate.contacts = action.payload;
      }
    },

    // Update paymentInfo array
    updatePayments: (state, action: PayloadAction<PaymentInfo[]>) => {
      if (state.vendorDate) {
        state.vendorDate.paymentInfo = action.payload;
      }
    },

    // Update documents array
    updateDocuments: (state, action: PayloadAction<Document[]>) => {
      if (state.vendorDate) {
        state.vendorDate.documents = action.payload;
      }
    },

    // Clear vendor state
    clearVendor: (state) => {
      state.vendorDate = null;
    },
  },
});

export const {
  setVendor,
  updateGeneralInfo,
  updateContacts,
  updatePayments,
  updateDocuments,
  clearVendor,
} = vendorSlice.actions;

export default vendorSlice.reducer;
